/** Please keep this file in sync with the backend schema validation. */

/** Maximum character length for shortcut/protocol prompt (query) field. */
export const SHORTCUT_PROMPT_MAX_LENGTH = 5000;

/** Maximum character length for shortcut/protocol name (label) field. */
export const SHORTCUT_NAME_MAX_LENGTH = 50;

/**
 * Maximum character length for shortcut description (UI-only subtitle; not the query).
 * Keep in sync with backend `PinnedQuery` / evidence config schema.
 */
export const SHORTCUT_DESCRIPTION_MAX_LENGTH = 500;

/** Maximum number of protocol shortcuts a user can pin. */
export const MAX_SHORTCUTS_LIMIT = 25;
